import BOMB_BOMB_SPLAT_IMAGE_URL from './bombSplat.png';
export { BOMB_BOMB_SPLAT_IMAGE_URL };
export const BOMB_BOMB_SPLAT_SPRITESHEET_DATA = {
    frames: {
        'bombSplat0001.png': {
            frame: { x: 1, y: 1260, w: 175, h: 131 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 91, y: 94, w: 175, h: 131 },
            sourceSize: { w: 349, h: 320 },
            anchor: { x: 0.508948, y: 0.526932 }
        },
        'bombSplat0002.png': {
            frame: { x: 1, y: 323, w: 275, h: 258 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 52, y: 16, w: 275, h: 258 },
            sourceSize: { w: 349, h: 320 },
            anchor: { x: 0.508948, y: 0.526932 }
        },
        'bombSplat0003.png': {
            frame: { x: 1, y: 1, w: 349, h: 320 },
            rotated: false,
            trimmed: false,
            spriteSourceSize: { x: 0, y: 0, w: 349, h: 320 },
            sourceSize: { w: 349, h: 320 },
            anchor: { x: 0.508948, y: 0.526932 }
        },
        'bombSplat0004.png': {
            frame: { x: 192, y: 583, w: 79, h: 82 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 137, y: 125, w: 79, h: 82 },
            sourceSize: { w: 349, h: 320 },
            anchor: { x: 0.508948, y: 0.526932 }
        },
        'bombSplat0005.png': {
            frame: { x: 161, y: 1910, w: 98, h: 103 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 127, y: 104, w: 98, h: 103 },
            sourceSize: { w: 349, h: 320 },
            anchor: { x: 0.508948, y: 0.526932 }
        },
        'bombSplat0006.png': {
            frame: { x: 373, y: 902, w: 114, h: 116 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 119, y: 91, w: 114, h: 116 },
            sourceSize: { w: 349, h: 320 },
            anchor: { x: 0.508948, y: 0.526932 }
        },
        'bombSplat0007.png': {
            frame: { x: 373, y: 781, w: 119, h: 120 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 117, y: 87, w: 119, h: 120 },
            sourceSize: { w: 349, h: 320 },
            anchor: { x: 0.508948, y: 0.526932 }
        },
        'bombSplat0008.png': {
            frame: { x: 354, y: 1415, w: 123, h: 123 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 115, y: 84, w: 123, h: 123 },
            sourceSize: { w: 349, h: 320 },
            anchor: { x: 0.508948, y: 0.526932 }
        },
        'bombSplat0009.png': {
            frame: { x: 367, y: 1018, w: 127, h: 126 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 113, y: 81, w: 127, h: 126 },
            sourceSize: { w: 349, h: 320 },
            anchor: { x: 0.508948, y: 0.526932 }
        },
        'bombSplat0010.png': {
            frame: { x: 354, y: 1284, w: 131, h: 129 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 111, y: 78, w: 131, h: 129 },
            sourceSize: { w: 349, h: 320 },
            anchor: { x: 0.508948, y: 0.526932 }
        },
        'bombSplat0011.png': {
            frame: { x: 359, y: 1147, w: 135, h: 132 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 109, y: 75, w: 135, h: 132 },
            sourceSize: { w: 349, h: 320 },
            anchor: { x: 0.508948, y: 0.526932 }
        },
        'bombSplat0012.png': {
            frame: { x: 352, y: 151, w: 140, h: 135 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 107, y: 72, w: 140, h: 135 },
            sourceSize: { w: 349, h: 320 },
            anchor: { x: 0.508948, y: 0.526932 }
        },
        'bombSplat0013.png': {
            frame: { x: 352, y: 288, w: 144, h: 138 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 105, y: 69, w: 144, h: 138 },
            sourceSize: { w: 349, h: 320 },
            anchor: { x: 0.508948, y: 0.526932 }
        },
        'bombSplat0014.png': {
            frame: { x: 352, y: 1, w: 148, h: 141 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 103, y: 66, w: 148, h: 141 },
            sourceSize: { w: 349, h: 320 },
            anchor: { x: 0.508948, y: 0.526932 }
        },
        'bombSplat0015.png': {
            frame: { x: 347, y: 1540, w: 152, h: 144 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 101, y: 63, w: 152, h: 144 },
            sourceSize: { w: 349, h: 320 },
            anchor: { x: 0.508948, y: 0.526932 }
        },
        'bombSplat0016.png': {
            frame: { x: 327, y: 1860, w: 156, h: 147 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 99, y: 60, w: 156, h: 147 },
            sourceSize: { w: 349, h: 320 },
            anchor: { x: 0.508948, y: 0.526932 }
        },
        'bombSplat0017.png': {
            frame: { x: 1, y: 1866, w: 158, h: 149 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 98, y: 58, w: 158, h: 149 },
            sourceSize: { w: 349, h: 320 },
            anchor: { x: 0.508948, y: 0.526932 }
        },
        'bombSplat0018.png': {
            frame: { x: 165, y: 1758, w: 160, h: 150 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 97, y: 57, w: 160, h: 150 },
            sourceSize: { w: 349, h: 320 },
            anchor: { x: 0.508948, y: 0.526932 }
        },
        'bombSplat0019.png': {
            frame: { x: 1, y: 1712, w: 162, h: 152 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 96, y: 55, w: 162, h: 152 },
            sourceSize: { w: 349, h: 320 },
            anchor: { x: 0.508948, y: 0.526932 }
        },
        'bombSplat0020.png': {
            frame: { x: 339, y: 1694, w: 164, h: 153 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 95, y: 54, w: 164, h: 153 },
            sourceSize: { w: 349, h: 320 },
            anchor: { x: 0.508948, y: 0.526932 }
        },
        'bombSplat0021.png': {
            frame: { x: 171, y: 1601, w: 166, h: 155 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 94, y: 52, w: 166, h: 155 },
            sourceSize: { w: 349, h: 320 },
            anchor: { x: 0.508948, y: 0.526932 }
        },
        'bombSplat0022.png': {
            frame: { x: 1, y: 1554, w: 168, h: 156 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 93, y: 51, w: 168, h: 156 },
            sourceSize: { w: 349, h: 320 },
            anchor: { x: 0.508948, y: 0.526932 }
        },
        'bombSplat0023.png': {
            frame: { x: 175, y: 1442, w: 170, h: 157 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 92, y: 50, w: 170, h: 157 },
            sourceSize: { w: 349, h: 320 },
            anchor: { x: 0.508948, y: 0.526932 }
        },
        'bombSplat0024.png': {
            frame: { x: 1, y: 1393, w: 172, h: 159 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 91, y: 48, w: 172, h: 159 },
            sourceSize: { w: 349, h: 320 },
            anchor: { x: 0.508948, y: 0.526932 }
        },
        'bombSplat0025.png': {
            frame: { x: 178, y: 1280, w: 174, h: 160 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 90, y: 47, w: 174, h: 160 },
            sourceSize: { w: 349, h: 320 },
            anchor: { x: 0.508948, y: 0.526932 }
        },
        'bombSplat0026.png': {
            frame: { x: 181, y: 1116, w: 176, h: 162 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 89, y: 45, w: 176, h: 162 },
            sourceSize: { w: 349, h: 320 },
            anchor: { x: 0.508948, y: 0.526932 }
        },
        'bombSplat0027.png': {
            frame: { x: 1, y: 1095, w: 178, h: 163 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 88, y: 44, w: 178, h: 163 },
            sourceSize: { w: 349, h: 320 },
            anchor: { x: 0.508948, y: 0.526932 }
        },
        'bombSplat0028.png': {
            frame: { x: 185, y: 950, w: 180, h: 164 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 87, y: 43, w: 180, h: 164 },
            sourceSize: { w: 349, h: 320 },
            anchor: { x: 0.508948, y: 0.526932 }
        },
        'bombSplat0029.png': {
            frame: { x: 1, y: 927, w: 182, h: 166 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 86, y: 41, w: 182, h: 166 },
            sourceSize: { w: 349, h: 320 },
            anchor: { x: 0.508948, y: 0.526932 }
        },
        'bombSplat0030.png': {
            frame: { x: 188, y: 781, w: 183, h: 167 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 86, y: 40, w: 183, h: 167 },
            sourceSize: { w: 349, h: 320 },
            anchor: { x: 0.508948, y: 0.526932 }
        },
        'bombSplat0031.png': {
            frame: { x: 1, y: 756, w: 185, h: 169 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 85, y: 38, w: 185, h: 169 },
            sourceSize: { w: 349, h: 320 },
            anchor: { x: 0.508948, y: 0.526932 }
        },
        'bombSplat0032.png': {
            frame: { x: 276, y: 609, w: 187, h: 170 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 84, y: 37, w: 187, h: 170 },
            sourceSize: { w: 349, h: 320 },
            anchor: { x: 0.508948, y: 0.526932 }
        },
        'bombSplat0033.png': {
            frame: { x: 1, y: 583, w: 189, h: 171 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 83, y: 36, w: 189, h: 171 },
            sourceSize: { w: 349, h: 320 },
            anchor: { x: 0.508948, y: 0.526932 }
        },
        'bombSplat0034.png': {
            frame: { x: 278, y: 434, w: 191, h: 173 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 82, y: 34, w: 191, h: 173 },
            sourceSize: { w: 349, h: 320 },
            anchor: { x: 0.508948, y: 0.526932 }
        },
        'bombSplat0035.png': {
            frame: { x: 192, y: 664, w: 79, h: 78 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 137, y: 129, w: 79, h: 78 },
            sourceSize: { w: 349, h: 320 },
            anchor: { x: 0.508948, y: 0.526932 }
        },
        'bombSplat0036.png': {
            frame: { x: 192, y: 664, w: 79, h: 78 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 137, y: 129, w: 79, h: 78 },
            sourceSize: { w: 349, h: 320 },
            anchor: { x: 0.508948, y: 0.526932 }
        }
    },
    animations: {
        animation: [
            'bombSplat0001.png',
            'bombSplat0002.png',
            'bombSplat0003.png',
            'bombSplat0004.png',
            'bombSplat0005.png',
            'bombSplat0006.png',
            'bombSplat0007.png',
            'bombSplat0008.png',
            'bombSplat0009.png',
            'bombSplat0010.png',
            'bombSplat0011.png',
            'bombSplat0012.png',
            'bombSplat0013.png',
            'bombSplat0014.png',
            'bombSplat0015.png',
            'bombSplat0016.png',
            'bombSplat0017.png',
            'bombSplat0018.png',
            'bombSplat0019.png',
            'bombSplat0020.png',
            'bombSplat0021.png',
            'bombSplat0022.png',
            'bombSplat0023.png',
            'bombSplat0024.png',
            'bombSplat0025.png',
            'bombSplat0026.png',
            'bombSplat0027.png',
            'bombSplat0028.png',
            'bombSplat0029.png',
            'bombSplat0030.png',
            'bombSplat0031.png',
            'bombSplat0032.png',
            'bombSplat0033.png',
            'bombSplat0034.png',
            'bombSplat0035.png',
            'bombSplat0036.png'
        ]
    },
    meta: {
        app: 'https://www.codeandweb.com/texturepacker',
        version: '1.0',
        image: BOMB_BOMB_SPLAT_IMAGE_URL,
        format: 'RGBA8888',
        size: { w: 494, h: 2016 },
        scale: '0.25',
        smartupdate: '$TexturePacker:SmartUpdate:d7bfd5c521654f6690cf1f8e68d6dbd3:97f8354fd25b6b031541bc759fba03db:68deb4a6c5abff62cb6fcebc9594e3ed$'
    }
};
